import React from 'react'

const Error = (props) => {
  return <div>Error found {JSON.stringify(props) || null}</div>
}

export default Error
